import { useNavigate } from 'react-router';
import login_Service from '../../../api/services/login_Service';
import { useEffect, useState } from 'react';
import newsPaper from "../../../assets/icons/Newspaper.svg";
import { useDispatch } from 'react-redux';
import { playSong } from '../../common/actions/common.actions';
import { IoIosArrowBack } from "react-icons/io";

const Rules = ({ setIsLoading }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [rules, setRules] = useState([]);
  const queryParams = new URLSearchParams(window.location.search);
  const loggedInParam = queryParams.get("loggedIn");
  const loggedIn = loggedInParam === "true";

  const handleSongClick = async () => {
    dispatch(playSong());
  };

  const handleClick = () => {
    handleSongClick();
    navigate('/dashboard');
  };

  const handleButtonClick = (redirectToDashboard) => {
    if (redirectToDashboard) {
      navigate('/dashboard');
    } else {
      navigate('/login');
    }
  };

  useEffect(() => {
    setIsLoading(true);
    login_Service.rule()
      .then(response => response.json())
      .then(data => {
        if (data) {
          setRules(data);
        }
        setIsLoading(false);
      })
      .catch(err => {
        setIsLoading(false);
        console.log(err);
      });
  }, [setIsLoading]);

  return (
    <div className="relative flex flex-col w-full h-[100dvh] overflow-hidden">
      <div className="absolute inset-0 bg-[linear-gradient(125deg,#C50825_50%,#A50D21_50%)]"></div>
      <div className="absolute top-16 -right-20 w-64 h-12 bg-ep_White/20 rounded-full rotate-[125deg]"></div>
      <div className="absolute top-2 -right-4 w-48 h-12 bg-ep_White/20 rounded-full rotate-[125deg]"></div>
      <div className="absolute -bottom-2 right-10 w-32 h-12 bg-ep_White/20 rounded-full rotate-[125deg]"></div>
      <div className="absolute top-20 left-10 h-24 w-14 text-white/60 bg-dot-pattern [background-size:12px_12px]" />
      <div className="absolute bottom-96 right-8 h-14 w-32 text-white/60 bg-dot-pattern [background-size:12px_12px]" />

      <div className="relative z-10 px-4 pt-4">
        <div className="flex items-center justify-between">
          {!loggedInParam && (
            <button
              onClick={handleClick}
              className="w-10 h-10 flex justify-center items-center text-ep_White hover:bg-ep_White/10 rounded-xl transition-all duration-300"
            >
              <IoIosArrowBack size={24} />
            </button>
          )}
          <div className="flex items-center gap-3 flex-1 justify-center">
            <div className="w-11 h-11 rounded-xl bg-ep_White/15 border border-ep_White/30 flex items-center justify-center shadow-lg">
              <img src={newsPaper} alt="rules" className="w-5 h-5 filter brightness-0 invert" />
            </div>
            <h3 className="text-lg font-bold text-ep_White leading-tight">Rules & Regulations</h3>
          </div>
          {!loggedInParam && <div className="w-10"></div>}
        </div>
      </div>

      <div className="relative z-10 px-4 pt-2 text-center">
        <p className="text-xs text-ep_White/90 font-bold uppercase tracking-widest">Please Read Carefully</p>
      </div>

      <div className="relative z-10 flex-1 overflow-auto px-4 py-4">
        <div className="space-y-3 pb-2">
          {rules.map((rule, index) => (
            <div
              key={rule.ruleId}
              className="bg-ep_White/10 backdrop-blur-sm rounded-xl border border-ep_White/20 shadow-md overflow-hidden"
            >
              <div className="py-3 px-4 border-b border-ep_White/15">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-ep_Gold rounded-lg flex items-center justify-center mr-3 mt-0.5 shadow-md flex-shrink-0">
                    <span className="text-white font-bold text-sm">{index + 1}</span>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-base font-bold text-ep_White leading-6">
                      {rule?.ruleTitle}
                    </h3>
                  </div>
                </div>
              </div>

              <div className="px-4 py-3">
                <p className="text-ep_White/90 leading-6 text-justify text-sm">
                  {rule?.descriptions}
                </p>
              </div>
            </div>
          ))}
        </div>

        {rules.length === 0 && (
          <div className="flex-1 flex items-center justify-center min-h-[320px]">
            <div className="text-center px-6 py-7 bg-ep_White/10 backdrop-blur-sm rounded-xl border border-ep_White/25 shadow-xl">
              <div className="w-14 h-14 bg-ep_Gold rounded-full flex items-center justify-center mx-auto mb-4">
                <img src={newsPaper} alt="rules" className="w-8 h-8 filter brightness-0 invert" />
              </div>
              <h3 className="text-lg font-semibold text-ep_White mb-2">No Rules Available</h3>
              <p className="text-sm text-ep_White/80">Rules and regulations will appear here.</p>
            </div>
          </div>
        )}
      </div>

      {loggedIn && (
        <div className="relative z-10 px-4 pb-5 pt-2">
          <div className="grid grid-cols-2 gap-3">
            <button
              className="w-full py-3 bg-ep_White/15 border border-ep_White/30 text-ep_White font-bold rounded-xl shadow-md transition-all duration-300 hover:bg-ep_White/20"
              onClick={() => handleButtonClick(false)}
            >
              ထွက်မည်
            </button>
            <button
              className="w-full py-3 bg-ep_Gold text-white font-bold rounded-xl shadow-lg transition-all duration-300 border border-ep_Gold/50"
              onClick={() => handleButtonClick(true)}
            >
              သဘောတူပါသည်
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Rules;
